/* ============================================================
   Yolanda Nano Water — product page
   One job: swap the gallery image. The measurement strip is
   deliberately NOT animated in — those numbers are the page's
   credibility and must not depend on JS or scroll position.
   Variants, quantity and the cart are Dawn's (product-info.js /
   product-form.js) and are not touched here.
   ============================================================ */
(function () {
  'use strict';

  function initGallery(root) {
    var main = root.querySelector('[data-nano-main]');
    var thumbs = root.querySelectorAll('[data-nano-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (!src || main.getAttribute('src') === src) return;

        main.setAttribute('src', src);
        main.setAttribute('alt', thumb.getAttribute('data-alt') || '');
        main.removeAttribute('srcset');

        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('.nano-pdp').forEach(function (root) {
      if (root.hasAttribute('data-nano-ready')) return;
      root.setAttribute('data-nano-ready', '');
      initGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn re-renders the section in the theme editor and on variant
  // change; re-bind rather than leaving a dead gallery behind.
  document.addEventListener('shopify:section:load', init);
})();
